import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import GoodsAction from "../../../../publicComponent/h5/GoodsAction";
import {useDispatch} from "react-redux";
import {setDrawerSearch} from "../../../../reducer/actions";
import ImgsSwiper from "./components/ImgsSwiper";
import GoodsSpec from "./components/GoodsSpec";
import GoodsDetailContext, {GoodsDetailController, useGoodsDetailContext} from "../../../../reducer/moduleReducer/goodsDetail";
import FooterMall9 from "../../../../publicComponent/Footer/FooterMall9";
import {isEmptyObj, mediaMatch} from "../../../../utils";
import FixedBar from "../../../../publicComponent/h5/FixedBar";
import AddCartButton from "../../../../reducer/moduleReducer/goodsDetail/components/AddCartButton";
import Buffer from "../../../../publicComponent/Buffer";
import LeftDetailBlock from "./components/LeftDetailBlock";
import RightDetailBlock from "./components/RightDetailBlock";
import Modal from "../../../../publicComponent/Modal";
import {useState} from "react";
import {useTranslation,getI18n} from "react-i18next";

function GoodsDetailWrap() {
  const { selectSpec, setSpecModalVisible,setSkuItem } = GoodsDetailController();
  const { state } = useGoodsDetailContext();
  const { detail, count, spec, specModalVisible,skuItem } = state;
  const detailLoading = state.detailLoading;
  const isMdmax = mediaMatch.isMdmax;
  const { t } = useTranslation();
  const lang = getI18n().language;

  if (detailLoading) return <Buffer.Loading/>;

  const selectSpecHandle = (item) => {
    selectSpec(item);
    setSpecModalVisible(false);
  };
  
  return (
    !isEmptyObj(state.detail)
    && <>
      {
        !isMdmax
          ? <div className="flex pt-[55px]">
            <LeftDetailBlock/>
            <RightDetailBlock/>
          </div>
          : <>
            <ImgsSwiper/>
            <GoodsSpec setSpecModalVisible={setSpecModalVisible}/>
            <GoodsAction className="py-[10px] pl-[20px] items-center">
              <FixedBar className="flex items-center pl-[20px]" style={{ border: '0', paddingRight: 0 }}>
                <h1 className="flex-none text-[#ECBC40] w-[40%] text-2xl font-bold">$ {detail.priceArea}</h1>
                <AddCartButton
                  noIcon
                  className="rounded-none mdmax:rounded-l-full bg-[#333] font-bold md:ml-[1.4rem] py-[12px] mdmax:py-[8px] mdmax:flex-1 md:w-[180px] bg-[#ECBC40] text-[16px] mdmax:text-[14px] flex-1"/>
              </FixedBar>
            </GoodsAction>
          </>
      }
      <Modal visible={specModalVisible}
             onClose={setSpecModalVisible}
             title={t('请选择规格')}>
        <div className="py-[20px]  px-[20px]">
          {/* {
            detail.specListRes.map((item, i) => {
              const isActive = item.specSkuId === spec.specSkuId;
              return (
                <span onClick={() => selectSpecHandle(item)}
                      className={`inline-block mb-[10px] rounded-[10px] py-[8px] px-[15px] border mr-[12px] text-[13px] ${isActive ? 'bg-[#333] text-white border-[#333]' : 'border-[#d4d4d4]'}`}
                      key={i}>{item.specName}</span>
              );
            })
          } */}
          {detail?.specList.map((item, i) => (
            <div className="mb-[10px] mr-[10px]" key={i}>
              <p className="text-[15px] inline-block mr-[10px]">
                {lang === "en" ? item.specNameEn : item.specName}:
              </p>
              {item.specNameValueList.map((_item, j) => (
                <a
                  key={j}
                  style={{ minWidth: 36 }}
                  onClick={() => setSkuItem(item, i, j)}
                  className={`inline-block text-center border border-[#ddd] p-[7px] px-[8px] rounded-full cursor-pointer ml-[8px] ${
                    _item === skuItem[i]?.specValue
                      ? "border-[#c7a17a] text-[#c7a17a]"
                      : ""
                  }`}
                >
                  {_item}
                </a>
              ))}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}

export default function GoodsDetail() {
  const dispatch = useDispatch();

  return (
    <>
      <HeaderMall9/>
      <Navigator backgroundColor={'transparent'}
                 title={'商品信息'}
                 right={(
                   <i className="iconfont icon-search text-[20px]"
                      onClick={() => dispatch(setDrawerSearch(true))}/>
                 )}
                 goback/>
      <GoodsDetailContext>
        <Navigator.container className="container-center">
          <GoodsDetailWrap/>
        </Navigator.container>
      </GoodsDetailContext>
      <FooterMall9 noTabs/>
    </>
  );
}
